(function () {
  'use strict';
  var theme = window.theme || {};
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || theme.settings.moneyFormat || '${{amount}}';
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }
  theme.formatMoney = formatMoney;

  /* The add-to-cart button is not a plain text button: it holds a cart icon and
     a live price span. Writing btn.textContent destroyed both, which is why the
     icon disappeared after the first add and the offer tiers then had nothing to
     write their price into. Swap only the label span. */
  function setBtnLabel(btn, text) {
    if (!btn) return;
    var spans = btn.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      if (s.hasAttribute('data-price-btn')) continue;
      if (s.classList.contains('dot')) continue;
      s.textContent = text;
      return;
    }
    btn.textContent = text;
  }

  var openDrawer = null;
  function open(drawer) {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) openDrawer.classList.remove('is-open');
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
    openDrawer = drawer;
  }
  function closeAll() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    $$('.modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    document.body.classList.remove('drawer-open');
    openDrawer = null;
  }
  theme.openCart = function () { open($('#CartDrawer')); };
  theme.closeDrawers = closeAll;

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-drawer-open]');
    if (t) { e.preventDefault(); open($(t.getAttribute('data-drawer-open'))); return; }
    if (e.target.closest('.js-drawer-close') || e.target.id === 'DrawerOverlay' || e.target.classList.contains('modal')) { closeAll(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  $$('[data-announcement-slider]').forEach(function (bar) {
    var slides = $$('.announcement-bar__slide', bar);
    if (slides.length < 2) return;
    var i = 0, speed = parseInt(bar.getAttribute('data-speed') || '5', 10) * 1000;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, speed);
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('.appear').forEach(function (el) { io.observe(el); });
  } else { $$('.appear').forEach(function (el) { el.classList.add('is-visible'); }); }

  /* ---------------- cart drawer ---------------- */

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Same rule the theme uses everywhere else: the list price is what this item
     would cost before the sitewide sale depth, landed on .95. */
  function listUnit(cents, pct) {
    if (!pct || pct <= 0 || cents <= 0) return cents;
    var raw = Math.round((cents * 100) / (100 - pct));
    var w = Math.floor(raw / 100);
    var n = w * 100 + 95;
    if (n <= cents) n = (w + 1) * 100 + 95;
    return n;
  }

  function famOf(title) {
    var tw = String(title || '').trim().split(/\s+/);
    if (tw[0] === 'The' && tw[1]) return 'The ' + tw[1];
    return '';
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function renderCart(cart) {
    var drawer = $('#CartDrawer');
    if (!drawer) return;
    var list = $('[data-cart-items]', drawer);
    var subtotal = $('[data-cart-subtotal]', drawer);
    var pct = parseInt(drawer.getAttribute('data-sale-pct'), 10) || 0;
    var freeShip = parseInt(drawer.getAttribute('data-free-ship'), 10) || 0;

    $$('[data-cart-count]').forEach(function (c) {
      c.textContent = cart.item_count;
      c.setAttribute('data-count', cart.item_count);
    });
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    var ship = $('[data-cart-ship]', drawer);
    var shipText = $('[data-cart-ship-text]', drawer);
    var shipBar = $('[data-cart-ship-bar]', drawer);
    var saveRow = $('[data-cart-saving]', drawer);
    var saveAmt = $('[data-cart-saving-amount]', drawer);

    if (!cart.items.length) {
      list.innerHTML = '<div class="cart__empty"><p>' +
        esc((theme.strings && theme.strings.cartEmpty) || 'Your cart is currently empty.') +
        '</p><a href="/collections/early-black-friday-sale">Shop the Early Black Friday Sale</a></div>';
      drawer.classList.add('is-empty');
      if (ship) ship.hidden = true;
      if (saveRow) saveRow.hidden = true;
      return;
    }
    drawer.classList.remove('is-empty');

    var wasTotal = 0;

    list.innerHTML = cart.items.map(function (item, idx) {
      var unitList = listUnit(item.original_price, pct);
      var lineWas = unitList * item.quantity;
      wasTotal += lineWas;

      var isFree = item.final_line_price === 0;
      var fam = famOf(item.product_title);
      var prices = '';
      if (lineWas > item.final_line_price) {
        prices += '<s class="cart-item__was">' + formatMoney(lineWas) + '</s>';
      }
      prices += '<span class="cart-item__now">' + formatMoney(item.final_line_price) + '</span>';
      if (isFree) prices += '<span class="cart-item__free">Free</span>';

      return '<div class="cart-item" data-line="' + (idx + 1) + '">' +
        '<a class="cart-item__media" href="' + esc(item.url) + '">' +
          (item.image ? '<img src="' + esc(sized(item.image, 400)) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-item__info">' +
          (fam ? '<div class="cart-item__fam">' + esc(fam) + '</div>' : '') +
          '<a class="cart-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (item.variant_title ? '<div class="cart-item__variant">' + esc(item.variant_title) + '</div>' : '') +
          '<div class="cart-item__controls">' +
            '<span class="cart-item__qty">' +
              '<button type="button" data-qty-change="-1" aria-label="Decrease">&minus;</button>' +
              '<input type="number" min="0" value="' + item.quantity + '" data-qty-input aria-label="Quantity">' +
              '<button type="button" data-qty-change="1" aria-label="Increase">+</button>' +
            '</span>' +
            '<button type="button" class="cart-item__remove" data-remove>Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-item__prices">' + prices + '</div>' +
      '</div>';
    }).join('');

    var saved = wasTotal - cart.total_price;
    if (saveRow && saveAmt) {
      if (saved > 0) { saveAmt.textContent = formatMoney(saved); saveRow.hidden = false; }
      else { saveRow.hidden = true; }
    }

    if (ship && shipText && shipBar) {
      if (freeShip > 0) {
        ship.hidden = false;
        var left = freeShip - cart.total_price;
        var pctBar = Math.min(100, Math.round((cart.total_price / freeShip) * 100));
        shipBar.style.width = pctBar + '%';
        shipText.innerHTML = left > 0
          ? 'You are <strong>' + formatMoney(left) + '</strong> away from free US shipping.'
          : '<span class="cart-ship__done">Your order ships free</span>';
      } else {
        ship.hidden = true;
      }
    }
  }

  function cartRequest(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function refreshCart() { return fetch(theme.routes.cart, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart); }
  theme.refreshCart = refreshCart;

  document.addEventListener('click', function (e) {
    var chg = e.target.closest('[data-qty-change]');
    if (chg) {
      var row = chg.closest('.cart-item'), input = $('[data-qty-input]', row);
      var q = Math.max(0, parseInt(input.value, 10) + parseInt(chg.getAttribute('data-qty-change'), 10));
      cartRequest(theme.routes.cartChange, { line: row.getAttribute('data-line'), quantity: q }).then(renderCart);
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); var r2 = rm.closest('.cart-item'); cartRequest(theme.routes.cartChange, { line: r2.getAttribute('data-line'), quantity: 0 }).then(renderCart); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-qty-input]')) {
      var row = e.target.closest('.cart-item');
      cartRequest(theme.routes.cartChange, { line: row.getAttribute('data-line'), quantity: parseInt(e.target.value, 10) || 0 }).then(renderCart);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || theme.settings.cartType !== 'drawer') return;
    e.preventDefault();
    var btn = $('[type=submit]', form);
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; setBtnLabel(btn, theme.strings.adding); }
    var fd = new FormData(form);
    fetch(theme.routes.cartAdd, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { alert(res.description || res.message); return; }
        return refreshCart().then(function () { closeAll(); theme.openCart(); });
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
  });

  function initProductForm(root) {
    var form = $('form[data-product-form]', root);
    if (!form || form.dataset.init) return;
    form.dataset.init = '1';
    var json = $('[data-product-json]', root);
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var idInput = $('[name=id]', form);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare-price]', root);
    var saveEl = $('[data-save]', root);
    var btn = $('[data-add-to-cart]', form);
    var mainImg = $('[data-main-image]', root);

    function selectedOptions() {
      return $$('[data-option-index]', form).map(function (el) {
        if (el.tagName === 'SELECT') return el.value;
        var checked = $('input:checked', el); return checked ? checked.value : null;
      });
    }
    function update() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      if (!variant) { if (btn) { btn.disabled = true; setBtnLabel(btn, theme.strings.unavailable); } return; }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) { if (variant.compare_at_price > variant.price) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
      if (saveEl) { if (variant.compare_at_price > variant.price) { saveEl.textContent = theme.strings.savePrice.replace('[saved_amount]', formatMoney(variant.compare_at_price - variant.price)); saveEl.hidden = false; } else saveEl.hidden = true; }
      if (btn) { btn.disabled = !variant.available; setBtnLabel(btn, variant.available ? theme.strings.addToCart : theme.strings.soldOut); }
      if (mainImg && variant.featured_image) mainImg.src = variant.featured_image.src;
      if (history.replaceState && root === document) { var u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u); }
    }
    form.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(); });
    $$('.product-gallery__thumbs img', root).forEach(function (th) {
      th.addEventListener('click', function () {
        if (mainImg) mainImg.src = th.getAttribute('data-full');
        $$('.product-gallery__thumbs img', root).forEach(function (x) { x.classList.remove('is-active'); }); th.classList.add('is-active');
      });
    });
  }
  theme.initProductForm = initProductForm;
  initProductForm(document);

  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-quick-view]');
    if (!qv) return;
    e.preventDefault();
    var modal = $('#QuickViewModal');
    if (!modal) { location.href = qv.getAttribute('data-quick-view'); return; }
    var body = $('[data-quick-view-body]', modal);
    body.innerHTML = '<p>Loading…</p>';
    modal.classList.add('is-open');
    fetch(qv.getAttribute('data-quick-view') + '?view=quick')
      .then(function (r) { return r.text(); })
      .then(function (html) { body.innerHTML = html; initProductForm(body); });
  });

  document.addEventListener('DOMContentLoaded', refreshCart);
})();
